import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";

const apiUrl:string = `${hostname}/aladdin_api/v1`;

const getReceiptData = (oauthTokenHeader: any, from_date: any, to_date: any) => {
    return fetchWrapper.get(`${apiUrl}/finance/receipts/?from=${from_date}&to=${to_date}`, oauthTokenHeader);
}

const getAllCurrencies = (oauthTokenHeader: any) => {
    return fetchWrapper.get(`${apiUrl}/meta/currencies/`, oauthTokenHeader);
}

const getPairingRate = (oauthTokenHeader:string,  QUERY_ID: string, from_date: any, to_date: any) => {
    return fetchWrapper.get(`${apiUrl}/biz_layer_query/run/${QUERY_ID}/?start_date=${from_date}&end_date=${to_date}`, oauthTokenHeader);
}

export const receiptServices = {
    getReceiptData, getAllCurrencies, getPairingRate
}
